import React from "react";
import AuthLayout from "../layouts/auth";
import OTPVerificationForm from "../components/otp-verification-form";
import { useTranslation } from "../contexts/I18nProvider";

function OtpVerification() {
  const { t } = useTranslation();

  return (
    <AuthLayout>
      <OTPVerificationForm />
    </AuthLayout>
  );
}

export default OtpVerification;
